import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Dialog, DialogActions, Popper, useMediaQuery, useTheme, } from "@mui/material";
import { CustomActionBar } from "./customActionBar";
/**
 *
 * @param {NerdPickerWrapperProps} props Component props
 * @returns {ReactElement} NerdPickerWrapper
 */
function NerdPickerWrapper(props) {
    const { dialogProps, popperProps, children, dialogActionBarProps, popperActionBarProps, } = props;
    const theme = useTheme();
    const isDownMd = useMediaQuery(theme.breakpoints.down("md"));
    if (isDownMd) {
        return (_jsxs(Dialog, { ...dialogProps, children: [children, dialogActionBarProps && (_jsx(DialogActions, { children: _jsx(CustomActionBar, { ...dialogActionBarProps }) }))] }));
    }
    else
        return (_jsxs(Popper, { ...popperProps, children: [children, popperActionBarProps && (_jsx(DialogActions, { children: _jsx(CustomActionBar, { ...popperActionBarProps }) }))] }));
}
export { NerdPickerWrapper };
